import { createSlice } from '@reduxjs/toolkit';
import { refreshSession, getUserDetails, logUserOutThunk } from './thunks';

const initialState = {
  hasUserDetails: false,
  userDetails: null,
  userDetailsLoading: false,

  isLoggingOut: false,
  refreshSessionLoading: false,
};

const slice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    resetAuthState: () => initialState,
  },
  extraReducers: {
    [refreshSession.fulfilled]: (state, { payload }) => {
      state.refreshSessionLoading = false;
    },
    [refreshSession.pending]: (state, { payload }) => {
      state.refreshSessionLoading = true;
    },
    [refreshSession.rejected]: (state, { payload }) => {
      state.refreshSessionLoading = false;
    },

    [logUserOutThunk.fulfilled]: (state, { payload }) => {
      state.isLoggingOut = false;
    },
    [logUserOutThunk.pending]: (state, { payload }) => {
      state.isLoggingOut = true;
    },
    [logUserOutThunk.rejected]: (state, { payload }) => {
      state.isLoggingOut = false;
    },
    [getUserDetails.fulfilled]: (state, { payload }) => {
      state.hasUserDetails = true;
      state.userDetails = payload;
      state.userDetailsLoading = false;
    },
    [getUserDetails.pending]: state => {
      state.hasUserDetails = false;
      state.userDetails = null;
      state.userDetailsLoading = true;
    },
    [getUserDetails.rejected]: state => {
      state.hasUserDetails = false;
      state.userDetails = null;
      state.userDetailsLoading = false;
    },
  },
});

export default slice.reducer;
